import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import GroupJoinDetails from "./group_join_details";

export default GrComponentFactory.createClass({
  displayName: "GroupJoinNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      title: React.PropTypes.string.isRequired,
      url: React.PropTypes.string.isRequired,
      memberCount: React.PropTypes.number,
      joinUrl: React.PropTypes.string,
      isMember: React.PropTypes.bool,
      imageUrl: React.PropTypes.string.isRequired,
      user: GrPropTypes.user().isRequired,
    }),
  },

  render() {
    const imageProps = { url: this.props.resource.imageUrl,
                         linkUrl: this.props.resource.url };
    const body = <SocialUpdateBody image={imageProps}>
                 <GroupJoinDetails {...this.props.resource}/>
               </SocialUpdateBody>;

    return <SocialUpdate
        header={<span>joined a group</span>}
        body={body}
        {...this.props}
      />;
  },
});
